import React from "react";
import "./Header.css";
import SearchIcon from "@material-ui/icons/Search";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import { Link } from "react-router-dom";
import { useStateValue } from "./StateProvider";
import { auth } from "./firebase";

function Header() {
  const [{ basket, user,blur ,addresses}, dispatch] = useStateValue();

  const handleAuthenticaton = () => {
    if (user) {
      auth.signOut();
    }
  }

  return (
    <div className={`header ${blur && 'blurs'}`}>
      <Link to="/" style={{textDecoration:"none"}}>
      <div className="header__logoborder">
        <img
          className="header__logo"
          src="http://pngimg.com/uploads/amazon/amazon_PNG11.png"
        />
      </div>
      </Link>
      <div className="header__address">
          <FmdGoodOutlinedIcon className="address__icon"/>
          <div className="address__text">
            <p className>Deliver to</p>
            <p className><h6>{addresses.length>0?address[0]:'Enter your address'}</h6></p>
          </div>
      </div>
      <div className="header__search">
        <input className="header__searchInput" type="text" />
        <SearchIcon className="header__searchIcon" />
      </div>

      <div className="header__nav">
        <Link to={!user && '/login'} style={{ textDecoration: 'none' }}>
        <div className="header__optionborder">
          <div onClick={handleAuthenticaton} className="header__option">
            <span className="header__optionLineOne"> {!user ? 'Guest' : user.email}</span>
            <span className="header__optionLineTwo">{user ? 'Sign Out' : 'Sign In'}</span>
          </div>
        </div>
        </Link>

        <Link to='/orders' style={{textDecoration:'none'}}>
        <div className="header__optionborder">
          <div className="header__option">
            <span className="header__optionLineOne">Returns</span>
            <span className="header__optionLineTwo">& Orders</span>
          </div>
        </div>
        </Link>
        
        <div className="header__optionborder">
        <div className="header__option">
          <span className="header__optionLineOne">Your</span>
          <span className="header__optionLineTwo">Prime</span>
        </div>
        </div>

        <Link to="/checkout" style={{textDecoration:'none'}}>
        <div className="header__optionbasketborder">
          <div className="header__optionBasket">
            <span className="header__optionLineTwo header__basketCount">
              items { basket?.length}
            </span>
            <ShoppingBasketIcon />
          </div>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Header;